import { Link } from "react-router-dom";
import { Logo } from "./Logo";

const LINKS = [
  { label: "Fitur", href: "#fitur" },
  { label: "Harga", href: "#harga" },
  { label: "FAQ", href: "#faq" },
];

export function Footer() {
  return (
    <footer className="border-t border-slate-800 bg-slate-950 pb-24 pt-12 md:pb-12">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr]">
          <div>
            <Logo dark />
            <p className="mt-4 max-w-md text-sm leading-relaxed text-slate-400">
              KalkuBisnis adalah aplikasi web untuk menghitung HPP, menentukan harga jual,
              memperkirakan BEP, dan mencatat penjualan usaha — praktis diakses lewat browser di
              HP atau komputer.
            </p>
          </div>
          <nav aria-label="Tautan footer">
            <p className="text-sm font-semibold text-white">Tautan</p>
            <ul className="mt-4 space-y-2.5">
              {LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                    className="text-sm text-slate-400 transition-colors hover:text-teal-400"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
              <li>
                <Link
                  to="/syarat-dan-ketentuan"
                  data-testid="footer-link-terms"
                  className="text-sm text-slate-400 transition-colors hover:text-teal-400"
                >
                  Syarat dan Ketentuan
                </Link>
              </li>
            </ul>
          </nav>
        </div>
        <div className="mt-10 border-t border-slate-800 pt-6">
          <p className="text-xs leading-relaxed text-slate-500">
            KalkuBisnis adalah alat bantu perhitungan dan pencatatan usaha. KalkuBisnis tidak
            menjamin keuntungan atau kesuksesan usaha tertentu.
          </p>
          <p className="mt-3 text-xs text-slate-500">
            © {new Date().getFullYear()} KalkuBisnis. Seluruh hak cipta dilindungi.
          </p>
        </div>
      </div>
    </footer>
  );
}
